import { defineStore } from 'pinia'
import service from '../utils/request.js'
import { permissionSignature } from '../utils/permissions.mjs'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    userInfo: null,
    initialized: false,
    userInfoRequest: null,
    errorStatus: null,
    authVersion: 0,
    identityVersion: 0,
    loggingOut: false
  }),
  getters: {
    // 已展示的身份与新路由准入分开：网络故障不把用户菜单切回未登录。
    isAuthenticated: state => !!state.userInfo && ![401, 403].includes(state.errorStatus) && !state.loggingOut,
    hasRouteAccess: state => !!state.userInfo && !state.errorStatus && !state.loggingOut,
    getUserInfo: state => state.userInfo
  },
  actions: {
    async initializeAuth() {
      if (this.userInfoRequest) return this.userInfoRequest
      if (this.initialized) return this.userInfo
      return this.fetchUserInfo()
    },
    clearAuth() {
      this.authVersion++
      this.userInfoRequest = null
      this.userInfo = null
      this.initialized = true
      this.errorStatus = null
    },
    async fetchUserInfo() {
      if (this.loggingOut) return null
      if (this.userInfoRequest) return this.userInfoRequest
      const version = this.authVersion
      const request = service.get('/auth/profile/', { skipAuthRedirect: true, silentError: true, timeout: 15000 })
        .then(response => {
          if (version !== this.authVersion) return this.userInfo
          if (this.userInfo?.id !== response.data?.id || permissionSignature(this.userInfo) !== permissionSignature(response.data)) {
            this.identityVersion++
          }
          this.userInfo = response.data
          this.initialized = true
          this.errorStatus = null
          return response.data
        })
        .catch(error => {
          if (version !== this.authVersion) return this.userInfo
          this.errorStatus = error.response?.status || 503
          if ([401, 403].includes(this.errorStatus)) {
            this.identityVersion++
            this.userInfo = null
            if (typeof document !== 'undefined') document.dispatchEvent(new Event('microquake:auth-expired'))
          }
          this.initialized = this.errorStatus === 401
          if (this.errorStatus === 401) return null
          throw error
        })
        .finally(() => { if (this.userInfoRequest === request) this.userInfoRequest = null })
      this.userInfoRequest = request
      return request
    },
    async logout() {
      if (this.loggingOut) return
      this.loggingOut = true
      // 退出一开始即废弃旧核验结果，避免慢请求恢复旧身份。
      this.authVersion++
      this.userInfoRequest = null
      try {
        const response = await service.post('/auth/logout/', {}, { skipAuthRedirect: true })
        this.clearAuth()
        window.location.assign(response.data.revoked === false ? '/login?auth_error=revoke_unconfirmed' : '/login?logged_out=1')
      } finally {
        this.loggingOut = false
      }
    }
  }
})
